import { IChartApi, LineType } from "lightweight-charts";
import { Dictionary } from "motw_core/Utils/Dictionary";
import { Emotion } from "source/app/domain/Emotions/Emotion";
import { IMappedData } from "../../../IMappedData";

export function DrawLineSeries(
    chart: IChartApi,
    emotion: Emotion,
    dictionary: Dictionary<string, IMappedData[]>
) {
    const lineSeries = chart.addLineSeries({
        color: emotion.hexColor,
        lineWidth: 2,
        lineType: LineType.Curved,
        lastValueVisible: false,
        priceLineVisible: false,
    });

    lineSeries.applyOptions({
        priceFormat: {
            type: "price",
            precision: 1,
            minMove: 1,
        },
    });

    const mappedData = dictionary
        .GetValues(emotion.character)!
        .map((mappedDataRow) => {
            const withColor: any = mappedDataRow;

            withColor.color =
                mappedDataRow.value === 0
                    ? `black`
                    : emotion.hexColor;

            return withColor;
        });

    lineSeries.setData(mappedData);

    return lineSeries;
}
